import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { memo, useRef } from 'react';
import useViewbox from '../../useViewbox.js';
const SvgArrowLong = memo((componentProps) => {
    const ref = useRef(null);
    useViewbox(ref);
    const props = {
        ...componentProps,
        ref,
        className: 'spriteIcon'
    };
    return (_jsx("svg", { fill: "currentColor", role: "presentation", viewBox: "0 0 20 7", ...props, children: _jsx("path", { d: "m16.61 6.847c-.221.204-.579.204-.79 0-.22-.205-.22-.536 0-.73l2.264-2.105h-17.526c-.305 0-.558-.232-.558-.516 0-.282.252-.516.558-.516h17.526l-2.263-2.094c-.221-.204-.221-.535 0-.73.105-.097.253-.156.4-.156s.284.049.4.156l3.21 2.97c.106.098.169.234.169.37s-.063.273-.169.37l-3.22 2.98z", fill: "currentColor" }) }));
});
export default SvgArrowLong;
//# sourceMappingURL=ArrowLong.js.map